module.exports = __webpack_public_path__ + "img/quit_icon.f279500c.svg";